var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "38px",
    viewBox: "0 0 44 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Outlined / Alert / warning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "29125---Add-agenda-to-call-report",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "21567-Create-Call-Report-Popup",
    transform: "translate(-661.000000, -316.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(443.000000, 235.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Alert-/-warning",
    transform: "translate(216.000000, 75.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,44 L46,44 L24,6 L2,44 Z M26,38 L22,38 L22,34 L26,34 L26,38 Z M26,30 L22,30 L22,22 L26,22 L26,30 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#F7971C"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.05395bd4b6ec42ec8afd7ec0b4035c2f.svg";
export { ForwardRef as ReactComponent };